import { Modal } from "react-bootstrap";
import styled from "styled-components";

interface Props {
  maxwidth?: string;
  overflowVisible?: boolean;
}

export const StyledModal = styled(Modal)<Props>`
  .modal-dialog-scrollable .modal-content {
    overflow: ${props => (props.overflowVisible ? "visible" : "hidden")};
  }
  .modal-dialog-scrollable .modal-body {
    overflow-y: ${props => (props.overflowVisible ? "visible" : "auto")};
  }

  @media (min-width: 576px) {
    .modal-dialog {
      max-width: ${props => (props.maxwidth ? props.maxwidth : "740px")};
    }
  }
`;

export const Header = styled(Modal.Header)`
  height: 60px;
  background-color: ${({ theme }) => theme.darkBlueBackground};
  color: #fff;
  font-weight: 600;
  font-size: 20px;
  align-items: center;
`;

export const CloseButton = styled.button`
  color: #fff;
  font-weight: 600;
  font-size: 30px;
  opacity: 1;
  text-shadow: none;
  background-color: transparent;
  border: 0;

  &:after {
    content: "×";
  }

  &:focus {
    outline: none;
  }
`;
